import React, { Component } from 'react';
import {numberParce} from '../../../../server/util'
class TotalRevenue extends Component {
    render() {
        const {data}=this.props
        return (
            <div className="mini-stat bg-5 clearfix rounded text-center">
            <span className="mini-stat-icon" style={{float:'none'}}><i className="fa fa-usd fg-5"></i></span>
            <div className="mini-stat-info">
                Total Transactions Revenue
                {data.loading?<span className='loading'></span>:<span>{numberParce(((data.data||{}).TotalTrxRevenue||{}).totalAmount).toFixed(2)}</span>}                
            </div>
        </div>
        );
    }
}
export default TotalRevenue;


// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Home/DashboardItems/totalRevenue.jsx